// Bulgarian translations (Български)
export const bg: Record<string, string> = {
  // Main Menu
  'menu.dashboard': 'Табло за управление',
  'menu.orderNew': 'Регистрация на продукт',
  'menu.deliveryList': 'Списък за доставка',
  'menu.delivery': 'Доставка',
  'menu.receipt': 'Печат на разписка/етикет',
  
  // Definitions
  'menu.definitions': 'Дефиниции',
  'menu.customers': 'Клиенти',
  'menu.products': 'Дефиниции на продукти',
  'menu.pricing': 'Дефиниции на цени',
  'menu.tailoring': 'Шивашки операции',
  'menu.attributes': 'Атрибути на продукти',
  'menu.users': 'Потребители',
  'menu.productOrdering': 'Ред на продуктите',
  'menu.discounts': 'Дефиниции на отстъпки',
  
  // Settings
  'menu.settings': 'Настройки',
  'menu.generalSettings': 'Общи настройки',
  'menu.permissions': 'Управление на разрешения',
  'menu.subscription': 'Абонамент',
  'menu.invoices': 'Управление на фактури',
  'menu.expenses': 'Въвеждане на разходи',
  'menu.zReport': 'Z Report',
  'menu.reportsAndAccounting': 'Отчети и счетоводство',
  'menu.systemAndCommunication': 'Система и комуникация',
  'menu.reportsList': 'Списък с разписки',
  'menu.accountStatement': 'Извлечение по сметка',
  'menu.tickets': 'Заявки за поддръжка',
  'menu.support': 'Поддръжка',
  'menu.profile': 'Профил',
  'menu.logout': 'Изход',
  'menu.notifications': 'SMS/WhatsApp известия',
  'menu.whatsappConnection': 'WhatsApp връзка',
  'menu.smsConnection': 'SMS връзка',
  
  // Dashboard
  'dashboard.title': 'Табло за управление',
  'dashboard.todaySales': 'Днешни продажби',
  'dashboard.totalOrders': 'Общо поръчки',
  'dashboard.pendingDeliveries': 'Чакащи доставки',
  'dashboard.activeCustomers': 'Активни клиенти',
  'dashboard.recentOrders': 'Последни поръчки',
  'dashboard.viewAll': 'Виж всички',
  'dashboard.quickActions': 'Бързи действия',
  'dashboard.newOrder': 'Нова поръчка',
  'dashboard.newCustomer': 'Нов клиент',
  'dashboard.deliveries': 'Доставки',
  'dashboard.reports': 'Отчети',
  'dashboard.today': 'Днес',
  'dashboard.yesterday': 'Вчера',
  'dashboard.week': 'Седмица',
  'dashboard.month': 'Месец',
  'dashboard.quarter': 'Тримесечие',
  'dashboard.year': 'Година',
  'dashboard.totalRevenue': 'Общи приходи',
  'dashboard.totalPieces': 'Общо бройки',
  'dashboard.cancelled': 'Отменени',
  'dashboard.inProcess': 'В процес',
  'dashboard.inProcessDesc': 'Поръчки в процес на обработка',
  'dashboard.ready': 'Готови',
  'dashboard.readyDesc': 'Готови за доставка',
  'dashboard.delivered': 'Доставени',
  'dashboard.deliveredDesc': 'Завършени поръчки',
  'dashboard.announcements': 'Обявления',
  'dashboard.announcementAll': 'Общи',
  'dashboard.announcementPrivate': 'Лични',
  
  // Service Types
  'service.tailor': 'Шивашки услуги',
  'service.dryCleaning': 'Сухо чистене',
  'service.washing': 'Пране',
  'service.ironing': 'Гладене',
  'service.shoeShine': 'Почистване на обувки',
  'service.carpet': 'Килим',
  'service.tailoring': 'Шивашки ремонт',
  'service.carpetWashing': 'Пране на килими',
  'service.selectService': 'Изберете услуга',
  'service.addToCart': 'Добави в количката',
  'service.total': 'Общо',
  
  // Order Create Page
  'orderCreate.cart': 'Количка',
  'orderCreate.totalPieces': 'Общо бройки',
  'orderCreate.plannedDelivery': 'Планирана доставка',
  'orderCreate.payment': 'Плащане',
  'orderCreate.save': 'Запази',
  'orderCreate.allCategories': 'Всички',
  'orderCreate.selectCustomer': 'Избери клиент',
  'orderCreate.selectCustomerPlaceholder': 'Избери клиент',
  'orderCreate.change': 'Промени',
  'orderCreate.select': 'Избери',
  'orderCreate.balance': 'Баланс',
  'orderCreate.searchCustomer': 'Търси по име, телефон или адрес... (Пример: иван+359123456)',
  'orderCreate.newCustomer': 'Нов клиент',
  'orderCreate.customerName': 'Име и фамилия',
  'orderCreate.customerPhone': 'Телефон',
  'orderCreate.customerEmail': 'Имейл',
  'orderCreate.customerAddress': 'Адрес',
  'orderCreate.addCustomer': 'Добави клиент',
  'orderCreate.customer': 'Клиент',
  'orderCreate.serviceType': 'Тип услуга',
  'orderCreate.clickToSelect': 'Кликнете за избор',
  'orderCreate.deliveryDate': 'Дата на доставка',
  'orderCreate.details': 'Детайли',
  'orderCreate.itemDetails': 'Детайли на артикула',
  'orderCreate.tailoringOperations': 'Шивашки операции',
  'orderCreate.tailoringTitle': 'Шивашки операции',
  'orderCreate.discount': 'Отстъпка',
  'orderCreate.discountLabel': 'Отстъпка (%)',
  'orderCreate.debt': 'Дълг',
  'orderCreate.credit': 'Кредит',
  'orderCreate.homeDelivery': 'Доставка до дома',
  'orderCreate.homeDeliveryAddress': 'Адрес',
  'orderCreate.addressRequired': 'Адресът е задължителен!',
  'orderCreate.subtotal': 'Междинна сума',
  'orderCreate.grandTotal': 'Обща сума',
  
  // Products
  'products.title': 'Дефиниции на продукти',
  'products.addNew': 'Нов продукт',
  'products.category': 'Категория',
  'products.name': 'Име на продукт',
  'products.price': 'Цена',
  'products.color': 'Цвят',
  'products.active': 'Активен',
  'products.actions': 'Действия',
  'products.search': 'Търси продукт...',
  'products.noProducts': 'Няма намерени продукти',
  'products.noCategoryProducts': 'Няма намерени продукти в тази категория',
  'products.emptyCart': 'Количката е празна',
  
  // Customers
  'customers.title': 'Клиенти',
  'customers.addNew': 'Нов клиент',
  'customers.search': 'Търси клиенти...',
  'customers.name': 'Име',
  'customers.phone': 'Телефон',
  'customers.email': 'Имейл',
  'customers.address': 'Адрес',
  'customers.balance': 'Баланс',
  'customers.actions': 'Действия',
  'customers.edit': 'Редактирай',
  'customers.delete': 'Изтрий',
  'customers.noCustomers': 'Няма намерени клиенти',
  'customers.tableCustomer': 'Клиент',
  'customers.tableContact': 'Контакт',
  'customers.tableAddress': 'Адрес',
  'customers.tableNotifications': 'Известия',
  'customers.tableBalance': 'Баланс',
  'customers.tableActions': 'Действия',
  'customers.totalCount': 'Общо {count} клиента',
  'customers.notes': 'Бележка',
  'customers.whatsappEnabled': 'WhatsApp',
  'customers.smsEnabled': 'SMS',
  'customers.searchPlaceholder': 'Търси по име, телефон, имейл или адрес... (Пример: иван+359123456)',
  'customers.updated': 'Клиентът е актуализиран',
  'customers.updateError': 'Клиентът не може да бъде актуализиран',
  'customers.added': 'Клиентът е добавен',
  'customers.addError': 'Клиентът не може да бъде добавен',
  'customers.deleted': 'Клиентът е изтрит',
  'customers.deleteError': 'Клиентът не може да бъде изтрит',
  'customers.deleteConfirm': 'Наистина ли искате да изтриете клиента "{name}"?',
  'customers.loadError': 'Клиентите не могат да бъдат заредени',
  'customers.noResults': 'Няма намерени резултати',
  'customers.showingFirst50': 'Показване на първите 50 резултата',
  'customers.totalResults': 'общо',
  
  // Users
  'users.title': 'Потребители',
  'users.addNew': 'Нов потребител',
  'users.name': 'Пълно име',
  'users.email': 'Имейл',
  'users.role': 'Роля',
  'users.pin': 'ПИН',
  'users.permissions': 'Разрешения',
  'users.allPermissions': 'Всички разрешения',
  'users.permissionCount': '{count} разрешения',
  'users.changePin': 'Промени ПИН',
  'users.edit': 'Редактирай',
  'users.newUser': 'Нов потребител',
  'users.editUser': 'Редактирай потребител',
  'users.editingUser': 'Редактиране на потребител {name}',
  'users.pinCode': 'ПИН код (4-6 цифри)',
  'users.selectRole': 'Изберете роля',
  'users.patron': 'Собственик',
  'users.kasiyer': 'Касиер',
  'users.sofor': 'Шофьор',
  'users.changePinTitle': 'Промяна на ПИН код',
  'users.newPin': 'Нов ПИН код',
  'users.confirmPin': 'Потвърдете ПИН код',
  'users.pinMismatch': 'ПИН кодовете не съвпадат',
  'users.pinRequired': 'ПИН кодът е задължителен',
  'users.pinLength': 'ПИН кодът трябва да бъде 4-6 цифри',
  'users.changingPinFor': 'Промяна на ПИН код за {name}',
  
  // Pricing Page
  'pricing.title': 'Дефиниции на цени',
  'pricing.search': 'Търси продукт...',
  'pricing.product': 'Продукт',
  'pricing.dryCleaning': 'Сухо чистене',
  'pricing.washing': 'Пране',
  'pricing.ironing': 'Гладене',
  'pricing.tailoring': 'Шивашки ремонт',
  'pricing.shoeShine': 'Почистване на обувки',
  'pricing.action': 'Действие',
  'pricing.save': 'Запази',
  'pricing.saving': 'Запазване',
  'pricing.pricesSaved': 'Цените са запазени',
  'pricing.pricesSaveError': 'Цените не могат да бъдат запазени',
  'pricing.noProducts': 'Няма намерени продукти',
  'pricing.loadError': 'Продуктите не могат да бъдат заредени',
  
  // Tailoring Page
  'tailoring.title': 'Шивашки операции',
  'tailoring.addNew': 'Нова операция',
  
  // Attributes Page
  'attributes.title': 'Атрибути на продукти',
  'attributes.colors': 'Цветове',
  'attributes.stains': 'Видове петна',
  'attributes.damages': 'Видове повреди',
  'attributes.add': 'Добави',
  
  // Permissions Page
  'permissions.title': 'Управление на разрешения',
  'permissions.subtitle': 'Задайте разрешения за роли собственик и касиер',
  'permissions.about': 'За управлението на разрешения',
  'permissions.patronInfo': '<strong>Собственик:</strong> Главна административна роля с всички системни разрешения.',
  'permissions.cashierInfo': '<strong>Касиер:</strong> Потребителска роля с ограничени разрешения за ежедневни операции.',
  'permissions.saveSuccess': 'Разрешенията са запазени',
  'permissions.saveError': 'Разрешенията не могат да бъдат запазени',
  'permissions.patron': 'Собственик',
  'permissions.cashier': 'Касиер',
  'permissions.patronRole': 'Пълен административен достъп',
  'permissions.cashierRole': 'Ограничен потребителски достъп',
  'permissions.activePermissions': 'Активни разрешения:',
  'permissions.selectAllPatron': 'Избери всички за собственик',
  'permissions.deselectAllPatron': 'Премахни всички за собственик',
  'permissions.selectAllCashier': 'Избери всички за касиер',
  'permissions.deselectAllCashier': 'Премахни всички за касиер',
  'permissions.saving': 'Запазване...',
  'permissions.permissionList': 'Списък с разрешения',
  'permissions.infoTitle': 'За управлението на разрешения',
  'permissions.infoText1': 'Главна административна роля с всички системни разрешения.',
  'permissions.infoText2': 'Потребителска роля с ограничени разрешения за ежедневни операции.',
  'permissions.infoText3': 'Промените влизат в сила след запазване.',
  'permissions.infoText4': 'Разрешенията могат да се персонализират за всяка роля.',
  
  // Driver Dashboard Page
  'driver.title': 'Табло за шофьор',
  'driver.todayRevenue': 'Днешни приходи',
  'driver.totalPieces': 'Общо бройки',
  'driver.pending': 'Чакащи',
  'driver.ready': 'Готови',
  'driver.pickup': 'Вземане',
  'driver.delivery': 'Доставка',
  
  // Subscription Page
  'subscription.title': 'Абонамент и фактуриране',
  'subscription.invoiceManagement': 'Управление на фактури',
  
  // Invoices Page
  'invoices.title': 'Управление на фактури',
  'invoices.subtitle': 'Преглед и изтегляне на абонаментни фактури',
  
  // Expenses Page
  'expenses.title': 'Въвеждане на разходи',
  'expenses.addNew': 'Нов разход',
  'expenses.total': 'Общо разходи',
  'expenses.totalToday': 'Общо днешни разходи',
  'expenses.deletePermission': 'ℹ️ Изтриването на разходи е разрешено само за ролята собственик.',
  'expenses.description': 'Описание',
  'expenses.amount': 'Сума',
  'expenses.category': 'Категория',
  'expenses.noExpenses': 'Няма разходи за днес',
  'expenses.newExpense': 'Нов разход',
  'expenses.descriptionLabel': 'Описание *',
  'expenses.amountLabel': 'Сума (лв) *',
  'expenses.categoryLabel': 'Категория *',
  'expenses.categoryPlaceholder': 'Изберете категория...',
  'expenses.deleteTitle': 'Изтриване на разход',
  'expenses.deleteConfirm': 'Наистина ли искате да изтриете този разход?',
  'expenses.descriptionField': 'Описание:',
  'expenses.categoryField': 'Категория:',
  'expenses.amountField': 'Сума:',
  'expenses.dateField': 'Дата:',
  'expenses.cancel': 'Отказ',
  'expenses.yesDelete': 'Да, изтрий',
  'expenses.deleting': 'Изтриване...',
  'expenses.saved': 'Разходът е запазен',
  'expenses.saveError': 'Разходът не може да бъде запазен',
  'expenses.deleted': 'Разходът е изтрит',
  'expenses.deleteError': 'Разходът не може да бъде изтрит',
  'expenses.loadError': 'Разходите не могат да бъдат заредени',
  'expenses.dateFilter': 'Филтър по дата',
  'expenses.showDateFilter': 'Избери период',
  'expenses.startDate': 'Начална дата',
  'expenses.endDate': 'Крайна дата',
  'expenses.applyFilter': 'Филтрирай',
  'expenses.clearFilter': 'Изчисти',
  'expenses.activeFilter': 'Активен филтър',
  'expenses.filterApplied': 'Филтърът по дата е приложен',
  'expenses.filterCleared': 'Филтърът е изчистен',
  'expenses.selectBothDates': 'Моля, изберете начална и крайна дата',
  
  // Delivery List Page
  'deliveryList.title': 'Списък за доставка',
  'deliveryList.search': 'Номер на разписка, име на клиент или телефон...',
  'deliveryList.all': 'Всички',
  'deliveryList.pending': 'Чакащи',
  'deliveryList.ready': 'Готови',
  'deliveryList.date': 'Дата',
  'deliveryList.pieces': 'Бройки',
  'deliveryList.amount': 'Сума',
  'deliveryList.readyButton': 'Готово',
  'deliveryList.receiptButton': 'Разписка',
  'deliveryList.noOrders': 'Няма намерени поръчки',
  'deliveryList.statusUpdated': 'Поръчката е маркирана като готова',
  'deliveryList.statusUpdateError': 'Статусът не може да бъде актуализиран',
  'deliveryList.loadError': 'Поръчките не могат да бъдат заредени',
  'deliveryList.whatsappSending': '📱 Изпращане на WhatsApp съобщение...',
  'deliveryList.smsSent': '📨 SMS съобщението е изпратено',
  
  // Delivery Page
  'deliveryPage.title': 'Доставка',
  'deliveryPage.search': 'Търси по номер на разписка, име, телефон или адрес...',
  'deliveryPage.pieces': 'Бройки',
  'deliveryPage.amount': 'Сума',
  'deliveryPage.payment': 'Плащане',
  'deliveryPage.deliverButton': 'Достави',
  'deliveryPage.noOrdersFound': 'Няма намерени готови поръчки',
  'deliveryPage.noReadyOrders': 'Няма поръчки готови за доставка',
  'deliveryPage.minSearchLength': 'Въведете поне 3 символа',
  'deliveryPage.paymentDialogTitle': 'Плащане при доставка',
  'deliveryPage.ordersLoadError': 'Поръчките не могат да бъдат заредени',
  'deliveryPage.searchError': 'Търсенето е неуспешно',
  'deliveryPage.deliverySuccess': 'Поръчката е успешно доставена',
  'deliveryPage.deliveryError': 'Доставката е неуспешна',
  'deliveryPage.whatsappSending': '📱 Изпращане на разписка чрез WhatsApp...',
  'deliveryPage.statusNotReady': 'Поръчката е намерена, но не е готова за доставка',
  'deliveryPage.statusPending': 'Чакаща - Моля, първо я маркирайте като готова на страницата "Списък за доставка"',
  'deliveryPage.statusDelivered': 'Доставена',
  'deliveryPage.statusCancelled': 'Отменена',
  'deliveryPage.receiptDelivered': '✅ *ДОСТАВЕНА*',
  
  // Receipt Page
  'receipt.title': 'Разписка и етикет',
  'receipt.customerReceipt': 'Разписка за клиент',
  'receipt.back': 'Назад',
  'receipt.print': 'Печат на разписка',
  'receipt.whatsappSend': 'Изпрати WhatsApp',
  'receipt.receiptNumber': 'Номер на разписка',
  'receipt.date': 'Дата',
  'receipt.time': 'Час',
  'receipt.product': 'Продукт',
  'receipt.quantity': 'Количество',
  'receipt.price': 'Цена',
  'receipt.totalPieces': 'Общо бройки',
  'receipt.subtotal': 'Междинна сума',
  'receipt.tax': 'ДДС',
  'receipt.total': 'ОБЩО',
  'receipt.payment': 'Плащане',
  'receipt.plannedDelivery': 'Планирана доставка',
  'receipt.notFound': 'Разписката не е намерена',
  'receipt.newOrder': 'Нова поръчка',
  'receipt.search': 'Търси и отпечатай разписка отново',
  'receipt.searchPlaceholder': 'Търси по номер на разписка, име на клиент или телефон...',
  'receipt.searchEmpty': 'Въведете номер на разписка или име на клиент',
  'receipt.noResults': 'Няма намерени резултати',
  'receipt.resultsCount': 'Намерени {count} резултата',
  'receipt.printButton': 'Печат на разписка',
  'receipt.products': 'Продукти',
  'receipt.loadError': 'Данните не могат да бъдат заредени',
  'receipt.whatsappOpening': 'Отваряне на WhatsApp...',
  'receipt.labelPrinting': 'Печат на етикет {current}/{total}...',
  'receipt.andLabel': 'и етикет',
  'receipt.stain': 'Петно',
  'receipt.damage': 'Повреда',
  'receipt.taxPercent': 'ДДС (20%)',
  
  // Payment Methods
  'payment.cash': 'В брой',
  'payment.card': 'Кредитна карта (ПОС)',
  'payment.creditCard': 'Кредитна карта',
  'payment.mealCard': 'Карта за храна',
  'payment.onDelivery': 'При доставка',
  'payment.account': 'Сметка',
  
  // Settings Page
  'settings.title': 'Настройки',
  'settings.general': 'Общи настройки',
  'settings.companyName': 'Име на фирма',
  'settings.language': 'Език',
  'settings.currency': 'Валута',
  'settings.currencyPosition': 'Позиция на валута',
  'settings.currencyPositionLeft': 'Отляво (лв100,00)',
  'settings.currencyPositionRight': 'Отдясно (100,00лв)',
  'settings.currencyPositionPreviewLeft': 'Символ отляво',
  'settings.currencyPositionPreviewRight': 'Символ отдясно',
  'settings.numberFormat': 'Формат на числа',
  'settings.currencyFormat': 'Формат на валута',
  'settings.showDecimals': 'Покажи десетични знаци',
  'settings.showDecimalsDesc': 'Показване на десетична част (стотинки) в цените',
  'settings.dateFormat': 'Формат на дата',
  'settings.deliveryDays': 'Срок на доставка (дни)',
  'settings.workOnSunday': 'Работа в неделя',
  'settings.defaultServiceType': 'Тип услуга по подразбиране',
  'settings.defaultServiceTypeDesc': 'Типът услуга, който автоматично се избира при отваряне на екрана за въвеждане на продукти',
  'settings.defaultCategory': 'Категория по подразбиране',
  'settings.defaultCategoryDesc': 'Категорията, която автоматично се избира при отваряне на екрана за въвеждане на продукти',
  'settings.companyLogo': 'Лого на фирма',
  'settings.logoDescription': 'Логото ще се показва на разписки и горе вляво в програмата. Препоръчителен размер: 200x80px',
  'settings.uploadLogo': 'Качи лого',
  'settings.removeLogo': 'Премахни лого',
  'settings.noLogo': 'Няма лого',
  'settings.receiptSettings': 'Настройки на разписка',
  'settings.taxRate': 'Данъчна ставка (%)',
  'settings.receiptFooterText': 'Текст в долния колонтитул на разписката',
  'settings.receiptNote': 'Долен колонтитул на разписка (Бележки)',
  'settings.socialMedia': 'Социални медии и контакти',
  'settings.instagram': 'Instagram',
  'settings.facebook': 'Facebook',
  'settings.website': 'Уебсайт',
  'settings.phone': 'Телефон',
  'settings.address': 'Адрес',
  'settings.dangerZone': 'Опасна зона',
  'settings.deleteDemoDataWarning': 'Изтриването на демо данните ще премахне всички записи на клиенти, поръчки, плащания и разходи.',
  'settings.productsWillBeKept': 'Дефинициите на продукти ще бъдат запазени.',
  'settings.deleteDemoDataTitle': 'Демо данните се изтриват',
  'settings.deleteDemoDataConfirm': 'Това действие не може да бъде отменено! Всички записи на клиенти, поръчки, плащания и разходи ще бъдат изтрити.',
  'settings.areYouSure': 'Наистина ли искате да продължите?',
  'settings.deleting': 'Изтриване...',
  'settings.yesDelete': 'Да, изтрий',
  'settings.deleteDemoData': 'Изтрий демо данни',
  'settings.save': 'Запази',
  'settings.loading': 'Зареждане...',
  
  // Toasts
  'toast.settingsSaved': 'Настройките са запазени',
  'toast.settingsError': 'Настройките не могат да бъдат запазени',
  'toast.settingsLoadError': 'Настройките не могат да бъдат заредени',
  'toast.logoUploaded': 'Логото е качено. Не забравяйте да запазите!',
  'toast.logoRemoved': 'Логото е премахнато. Не забравяйте да запазите!',
  'toast.logoSizeError': 'Файлът с логото трябва да бъде по-малък от 500 KB',
  'toast.logoTypeError': 'Могат да се качват само файлове с изображения',
  
  // WhatsApp Connection Page
  'whatsapp.title': 'WhatsApp връзка',
  'whatsapp.subtitle': 'Управление на WhatsApp Business API връзка',
  'whatsapp.connectionStatus': 'Състояние на връзката',
  'whatsapp.disconnected': 'Прекъсната',
  'whatsapp.notConnectedMessage': 'Вашият WhatsApp акаунт все още не е свързан',
  'whatsapp.connectWithQR': 'Свържете се с QR код',
  'whatsapp.importantInfo': 'Важна информация',
  'whatsapp.info1': '1. Сканирайте QR кода с WhatsApp приложението на телефона си',
  'whatsapp.info2': '2. След свързване можете да изпращате автоматични съобщения',
  'whatsapp.info3': '3. За прекъсване излезте от WhatsApp настройките',
  'whatsapp.info4': '4. QR кодът се обновява автоматично след 60 секунди',
  'whatsapp.generateQR': 'Генерирай QR код',
  
  // Common
  'common.yes': 'Да',
  'common.no': 'Не',
  'common.cancel': 'Отказ',
  'common.confirm': 'Потвърди',
  'common.delete': 'Изтрий',
  'common.edit': 'Редактирай',
  'common.save': 'Запази',
  'common.search': 'Търси',
  'common.loading': 'Зареждане...',
  'common.noData': 'Няма данни',
  'common.actions': 'Действия',
  'common.status': 'Статус',
  'common.date': 'Дата',
  'common.time': 'Час',
  'common.total': 'Общо',
  'common.close': 'Затвори',
  'common.back': 'Назад',
  'common.submit': 'Изпрати',
  'common.create': 'Създай',
  'common.creating': 'Създаване...',
  'common.later': 'По-късно',
  'common.perPage': 'Per Page',
  'common.page': 'Page',
  'common.orders': 'Orders',
  'common.previous': 'Previous',
  'common.next': 'Next',
  'common.pieces': 'pieces',
  
  // Tickets
  'tickets.title': 'Заявки за поддръжка',
  'tickets.newTicket': 'Нова заявка',
  'tickets.noTickets': 'Все още няма заявки за поддръжка',
  'tickets.noTicketsDesc': 'Ако имате проблем, можете да създадете нова заявка за поддръжка',
  'tickets.subject': 'Тема',
  'tickets.description': 'Описание',
  'tickets.yourName': 'Вашето име',
  'tickets.yourNamePlaceholder': 'Въведете вашето име',
  'tickets.subjectPlaceholder': 'Обобщете проблема си накратко',
  'tickets.descriptionPlaceholder': 'Опишете проблема си подробно',
  'tickets.created': 'Заявката за поддръжка е създадена',
  'tickets.createError': 'Заявката за поддръжка не може да бъде създадена',
  'tickets.fillAllFields': 'Попълнете всички полета',
  'tickets.loadError': 'Заявките не могат да бъдат заредени',
  'tickets.messages': 'Съобщения',
  'tickets.status.open': 'Отворена',
  'tickets.status.investigating': 'В обработка',
  'tickets.status.waitingCustomer': 'Изчакване на клиент',
  'tickets.status.closed': 'Решена',
  'tickets.conversation': 'Разговор',
  'tickets.admin': 'Екип за поддръжка',
  'tickets.typeMessage': 'Въведете вашето съобщение...',
  'tickets.sendError': 'Съобщението не може да бъде изпратено',
  'tickets.closedMessage': 'Тази заявка е маркирана като решена.',
  'tickets.rateSupport': 'Оценете поддръжката',
  'tickets.rateExperience': 'Оценете вашия опит',
  'tickets.rateDescription': 'Как бихте оценили получената поддръжка?',
  'tickets.selectRating': 'Моля, изберете оценка',
  'tickets.ratingSubmitted': 'Вашата оценка е запазена, благодарим ви!',
  'tickets.ratingError': 'Оценката не може да бъде изпратена',
  'tickets.yourRating': 'Вашата оценка',
  'tickets.rating.veryBad': 'Много лоша',
  'tickets.rating.bad': 'Лоша',
  'tickets.rating.okay': 'Добре',
  'tickets.rating.good': 'Добра',
  'tickets.rating.excellent': 'Отлична',
  
  // Login
  'login.title': 'Cleandy',
  'login.subtitle': 'Система за управление на химическо чистене',
  'login.tenantId': 'ID на фирма',
  'login.tenantPlaceholder': 'id-на-фирма (напр.: acme-clean)',
  'login.tenantIdHelp': 'Въведете вашия уникален идентификатор на фирма',
  'login.continue': 'Продължи →',
  'login.notMember': 'Все още не сте член?',
  'login.startTrial': 'Започнете безплатен пробен период',
  'login.adminLogin': '🔒 Вход за администратор',
  'login.enterPin': 'Въведете вашия ПИН код',
  'login.changeTenant': 'Смени фирма',
  'login.clear': 'Изчисти',
  'login.delete': 'Изтрий',
  'login.login': 'Вход',
  'login.loggingIn': 'Влизане...',
  'login.defaultPinOwner': 'ПИН по подразбиране: <strong>1234</strong> (Собственик)',
  'login.defaultPinCashier': 'ПИН по подразбиране: <strong>0000</strong> (Касиер)',
  'login.systemInitializing': 'Системата се инициализира...',
  'login.pinMinLength': 'ПИН трябва да бъде поне 4 цифри',
  'login.invalidTenantId': 'Въведете валиден ID на фирма',
  'login.tenantNotFound': 'Този код на фирма не е намерен. Моля, проверете или създайте нов акаунт.',
  'login.loginFailed': 'Влизането е неуспешно',
  'login.welcome': 'Добре дошли, {name}',
  'login.tagline': 'Софтуер за химическо чистене — Интелигентни и лесни решения за вашия бизнес',

  // Signup translations
  'signup.title': 'Започнете безплатен пробен период',
  'signup.subtitle': '15 дни безплатно, не е необходима кредитна карта',
  'signup.backToLogin': 'Обратно към вход',
  'signup.companyCode': 'Код на фирма',
  'signup.companyCodePlaceholder': 'напр.: cleanpro',
  'signup.companyCodeHelp': 'Този код ще се използва за влизане в системата',
  'signup.companyCodeMinLength': 'Кодът на фирмата трябва да бъде поне 3 символа',
  'signup.companyName': 'Име на фирма',
  'signup.companyNamePlaceholder': 'Името на вашата фирма',
  'signup.companyNameRequired': 'Името на фирмата е задължително',
  'signup.fullName': 'Пълно име',
  'signup.fullNamePlaceholder': 'Вашето пълно име',
  'signup.fullNameRequired': 'Пълното име е задължително',
  'signup.phone': 'Телефон',
  'signup.phonePlaceholder': '+359 88 123 4567',
  'signup.validPhoneRequired': 'Моля, въведете валиден телефонен номер',
  'signup.email': 'Имейл',
  'signup.emailPlaceholder': 'primer@firma.bg',
  'signup.validEmailRequired': 'Моля, въведете валиден имейл адрес',
  'signup.createAccount': 'Създай акаунт',
  'signup.creating': 'Създаване...',
  'signup.terms': 'Създавайки акаунт, вие се съгласявате с нашите Условия за ползване и Политика за поверителност.',
  'signup.success': 'Регистрацията е успешна! Данните за вход са изпратени на вашия имейл.',
  'signup.successTitle': 'Регистрацията е успешна!',
  'signup.successMessage': 'Вашият акаунт е създаден успешно.',
  'signup.emailSent': 'Данните за вход са изпратени на вашия имейл.',
  'signup.redirecting': 'Пренасочване към страницата за вход...',
  'signup.startupPackageLoaded': 'Стартовият пакет е зареден!',
  'signup.products': 'Продукт',
  'signup.customers': 'Клиент',
  'signup.users': 'Потребител',
  'signup.demoDataReady': '✨ Вашите демо данни са готови, можете да започнете веднага!',
  'signup.loginInfo': '📧 Вашите данни за вход',
  'signup.loginInfoSent': '💡 Тези данни за вход също са изпратени на вашия имейл',
  'signup.loginNow': 'Влезте сега →',
  
  // Account Statement Page
  'accountStatement.title': 'Извлечение по сметка',
  'accountStatement.subtitle': 'Проследяване на вземания по клиент',
  'accountStatement.selectCustomer': 'Избери клиент',
  'accountStatement.customerPlaceholder': 'Избери клиент...',
  'accountStatement.searchCustomer': 'Търси по име, телефон или адрес...',
  'accountStatement.noCustomerSelected': 'Моля, изберете клиент',
  'accountStatement.currentBalance': 'Текущ баланс',
  'accountStatement.totalDebt': 'Общ дълг',
  'accountStatement.totalPayments': 'Общо плащания',
  'accountStatement.transactions': 'Транзакции',
  'accountStatement.noTransactions': 'Няма намерени записи за транзакции за този клиент',
  'accountStatement.date': 'Дата',
  'accountStatement.description': 'Описание',
  'accountStatement.debit': 'Дебит',
  'accountStatement.credit': 'Кредит',
  'accountStatement.balance': 'Баланс',
  'accountStatement.order': 'Поръчка',
  'accountStatement.payment': 'Плащане',
  'accountStatement.loadError': 'Извлечението по сметка не може да бъде заредено',
  'accountStatement.addPayment': 'Добави плащане',
  'accountStatement.paymentAmount': 'Сума на плащане',
  'accountStatement.paymentMethod': 'Метод на плащане',
  'accountStatement.paymentNotes': 'Бележки (незадължително)',
  'accountStatement.recordPayment': 'Запиши плащане',
  'accountStatement.paymentSaved': 'Плащането е записано',
  'accountStatement.paymentError': 'Плащането не може да бъде записано',
  'accountStatement.selectCustomerFirst': 'Моля, първо изберете клиент',
  'accountStatement.exportStatement': 'Експортирай извлечение',
  'accountStatement.exportStatementPDF': 'Изтегли PDF',
  'accountStatement.noCustomersFound': 'Няма намерени клиенти',
  'accountStatement.searchHint': 'Въведете поне 2 символа за търсене на клиенти',
  'accountStatement.selectedCustomer': 'Избран клиент',
  'accountStatement.changeCustomer': 'Смени клиент',
  
  // Toast Messages
  'toast.usernameRequired': 'Потребителското име е задължително',
  'toast.firstLoginChangePin': '⚠️ Първо влизане - Моля, променете вашия ПИН код',
  'toast.tenantNotFound': 'Фирмата не е намерена: "{tenantId}"\\n\\nМоля, кликнете на "Започнете безплатен пробен период", за да създадете нов акаунт на фирма.',
  'toast.tenantIdNotRemembered': '🗑️ ID на фирмата няма да бъде запомнено',
  'toast.demoDataLoaded': 'Демо потребители, продукти, клиенти и поръчки са създадени!',
  
  'toast.productsLoadError': 'Грешка при зареждане на продуктите',
  'toast.statsLoadError': 'Грешка при зареждане на статистиките',
  'toast.deliveryBeforeToday': 'Датата на доставка не може да бъде преди днес',
  'toast.customerOpenOrders': 'Клиентът има {count} отворени поръчки',
  'toast.customerDebt': 'Клиентът има дълг от {amount}',
  'toast.customerSaved': 'Клиентът е запазен',
  'toast.customerSaveError': 'Грешка при запазване на клиента',
  'toast.customerUpdated': 'Клиентът е актуализиран',
  'toast.customerUpdateError': 'Грешка при актуализиране на клиента',
  'toast.productAddedToCart': 'Продуктът е добавен в количката',
  'toast.enterValidArea': 'Моля, въведете валидна площ',
  'toast.carpetsAddedToCart': '{count} килима са добавени в количката ({area} м² x {price}/м²)',
  'toast.carpetAddedToCart': 'Килимът е добавен в количката ({area} м² x {price}/м²)',
  'toast.selectAtLeastOneService': 'Моля, изберете поне една услуга',
  'toast.productAdded': 'Продуктът е добавен',
  'toast.productDetailsUpdated': 'Детайлите на продукта са актуализирани',
  'toast.priceUpdated': 'Цената е актуализирана',
  'toast.fillAllCardInfo': 'Моля, попълнете всички данни на картата',
  'toast.invalidCardNumber': 'Невалиден номер на карта',
  'toast.invalidMonth': 'Невалиден месец (трябва да бъде между 1-12)',
  'toast.invalidYear': 'Невалидна година',
  'toast.invalidCvc': 'Невалиден CVC',
  'toast.cardPaymentSuccess': 'Плащането с карта е успешно!',
  'toast.cardPaymentError': 'Плащането с карта е неуспешно',
  'toast.paymentFailed': 'Плащането е неуспешно. Моля, опитайте отново.',
  'toast.paymentStatusCheckError': 'Грешка при проверка на статуса на плащането. Моля, проверете вашия акаунт.',
  'toast.selectCustomer': 'Моля, изберете клиент',
  'toast.addProduct': 'Моля, добавете продукт',
  'toast.addressRequiredForDelivery': 'За доставка до дома е необходим адрес на клиент. Моля, добавете адрес.',
  'toast.orderSaved': 'Поръчката е запазена',
  'toast.orderSaveError': 'Грешка при запазване на поръчката',
  'toast.enterValidValue': 'Въведете валидна стойност (0-100)',
  'toast.enterValidAmount': 'Въведете валидна сума',
  'toast.amountExceedsRemaining': 'Сумата не може да надвишава оставащия баланс',
  'toast.selectPaymentMethodFirst': 'Първо изберете метод на плащане и въведете сума',
  'toast.selectAtLeastOneOperation': 'Моля, изберете поне една операция',
  'toast.tailorAddedToCart': 'Шивашката операция е добавена в количката',
  
  'toast.receiptCopied': '📋 Разписката е копирана! Изберете контакт в WhatsApp Web и поставете (Ctrl+V)',
  'toast.autoCopyFailed': '⚠️ Автоматичното копиране е неуспешно. Моля, копирайте ръчно от прегледа.',
  'toast.printingLabel': 'Печат на етикет {current}/{total}...',
  'toast.markedAsReady': '✅ Поръчката е маркирана като готова',
  'toast.messageCopied': '📋 Съобщението е копирано! Поставете в WhatsApp (Ctrl+V)',
  'toast.whatsappSending': 'Изпращане на WhatsApp съобщение...',
  'toast.readyMarkError': 'Грешка при маркиране като готова',
  'toast.markedAsDelivered': '✅ Поръчката е маркирана като доставена',
  'toast.deliveredMarkError': 'Грешка при маркиране като доставена',
  'toast.copyFailed': '⚠️ Копирането е неуспешно. Изберете текста и натиснете Ctrl+C',
  'toast.textSelected': '✅ Текстът е избран! Копирайте с Ctrl+C',
  'toast.textSelectFailed': 'Текстът не може да бъде избран',
  'toast.statusUpdated': 'Статусът е актуализиран',
  'toast.smsSent': 'SMS е изпратено',
  'toast.statusUpdateError': 'Грешка при актуализиране на статуса',
  'toast.cancelReasonRequired': 'Причината за отмяна е задължителна',
  'toast.orderCancelled': 'Поръчката е отменена',
  'toast.cancelError': 'Грешка при отмяна',
  'toast.deliverySuccess': 'Доставката е успешна',
  'toast.deliveryError': 'Грешка при доставка',
  'toast.orderSetToReady': 'Поръчката е маркирана като готова',
  
  'toast.tenantIdNotFound': 'ID на наемател не е намерено',
  'toast.demoProductsLoaded': 'Демо продукти са заредени!',
  'toast.productsAddError': 'Грешка при добавяне на продуктите',
  'toast.englishNamesMigration': 'Английски имена са добавени към {count} продукта',
  'toast.migrationFailed': 'Миграцията е неуспешна',
  'toast.multiLanguageConversion': '✅ {count} продукта са конвертирани в многоезичен формат!',
  'toast.multiLanguageConversionError': 'Грешка при многоезична конверсия',
  'toast.productNameRequired': 'Името на продукта е задължително',
  'toast.productUpdated': 'Продуктът е актуализиран',
  'toast.productDeleted': 'Продуктът е изтрит',
  'toast.productDeleteError': 'Грешка при изтриване на продукта',
  
  'toast.whatsappNotInStarter': '⚠️ WhatsApp функцията не е налична във вашия Starter план. Можете да надстроите до Professional или Enterprise.',
  'toast.schemaError': '⚠️ Схемата на базата данни не съществува!\\n\\nНастройки → "🗄️ Зареди схема" → Стартирайте в Supabase SQL Editor',
  
  // Order Page
  'order.deliveryDate': 'Дата на доставка',
  'order.notes': 'Бележки',
  'order.createOrder': 'Създай поръчка',
  'order.cancel': 'Отказ',
  'order.discountRate': 'Отстъпка',
  'order.discountPercent': 'Отстъпка ({percent}%)',
  'order.discountOptional': 'Отстъпка (незадължителна)',
  'order.enterDiscountRate': 'Въведете процент отстъпка (0-100):',
  'order.quickDiscount': 'Бутони за бърза отстъпка',
  'order.discountSummary': 'Обобщение на отстъпки',
  'order.debt': 'Дълг',
  'order.receivable': 'Вземане',
  'order.balanced': 'Балансирано',
  'order.totalDebt': 'Общ дълг',
  'order.totalPayments': 'Общо плащания',
  'order.homeDeliveryShort': 'Доставка до дома',
  'order.homeDeliveryIcon': '🏠 Доставка до дома',
  'order.addressIcon': '📍 Адрес',
  'order.addressRequiredForDelivery': 'За доставка до дома е необходим адрес',
  'order.priceAndDiscountEdit': 'Редактиране на цена и отстъпка',
  'order.discount': 'Отстъпка',
  'order.subtotal': 'Междинна сума',
  'order.tax': 'ДДС',
  'order.grandTotal': 'Обща сума',
  'order.payment': 'Плащане',
  'order.paymentMethod': 'Метод на плащане',
  'order.cash': 'В брой',
  'order.card': 'Кредитна карта',
  'order.credit': 'На кредит',
  'order.amountPaid': 'Платена сума',
  'order.remainingBalance': 'Оставаща сума',
};
